import React from 'react';
import './LeftPanel.css';

function LeftPanel({ activeTool, onToolSelect }) {
  const tools = [
    { id: 'brush', icon: '✎', tooltip: '브러시' },
    { id: 'eraser', icon: '⌫', tooltip: '지우개' },
    { id: 'fill', icon: '▣', tooltip: '페인트 통' },
    { id: 'eyedropper', icon: '◉', tooltip: '스포이드' }
  ];

  return (
    <div className="left-panel">
      {tools.map(tool => (
        <button
          key={tool.id}
          className={`tool-button ${activeTool === tool.id ? 'active' : ''}`}
          title={tool.tooltip}
          onClick={() => onToolSelect(tool.id)}
        >
          <span className="tool-icon">{tool.icon}</span>
        </button>
      ))}
    </div>
  );
}

export default LeftPanel;